import React, { Children, cloneElement } from 'react';
import { getIn } from 'formik';
import ButtonGroup from './ButtonGroup';
import FormInputFeedback from '../feedback/FormInputFeedback';
import formPropTypes from '../../prop-types/formPropTypes';

var FormButtonGroup = function FormButtonGroup(_ref) {
  var id = _ref.id,
      form = _ref.form,
      field = _ref.field,
      title = _ref.title,
      buttonType = _ref.buttonType,
      buttonSize = _ref.buttonSize,
      buttonSkin = _ref.buttonSkin,
      labelOnly = _ref.labelOnly,
      role = _ref.role,
      children = _ref.children,
      flexWrap = _ref.flexWrap;
  var error = getIn(form.errors, field.name);
  var touch = getIn(form.touched, field.name);
  var isSubmitted = form.submitCount > 0;
  var renderChildren = Children.map(children, function (child) {
    return /*#__PURE__*/cloneElement(child, {
      buttonType: buttonType,
      buttonSize: buttonSize,
      buttonSkin: buttonSkin,
      labelOnly: labelOnly
    });
  });
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    buttonType: buttonType,
    buttonSize: buttonSize,
    buttonSkin: buttonSkin,
    role: role,
    "aria-label": title,
    flexWrap: flexWrap
  }, renderChildren, error && (touch || isSubmitted) && /*#__PURE__*/React.createElement(FormInputFeedback, {
    feedbackType: "error",
    id: id,
    message: error
  }));
};

FormButtonGroup.defaultProps = {
  buttonType: 'default',
  buttonSize: 'default',
  buttonSkin: 'primary',
  labelOnly: false,
  children: null,
  flexWrap: 'wrap'
};
export default FormButtonGroup;